









import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { getMyFavoritesSpList } from '@/components/my-favorites/api';
import { cancelTabReddot } from './api';
import { NS } from '@/components/my-favorites/types';

@Component({})
export default class FavoritesTab extends Vue {
  @Prop() classId!: string;
  @Prop() name!: string;
  timerId!: null|number;
  showReddot =  false;
  get isFavoritesTab() {
    return this.classId === NS.Favorites;
  }
  @Watch('classId')
  public onClassIdChange() {
    this.cancelReddot();
  }
  cancelReddot() {
    if (this.showReddot && this.isFavoritesTab) {
      if (this.timerId) {
        clearTimeout(this.timerId);
        this.timerId = null;
      }
      this.timerId = setTimeout(() => {
        cancelTabReddot();
        this.showReddot = false;
      }, 500);
    }
  }
  async init() {
    const res = await getMyFavoritesSpList(0, 1);
    this.showReddot = res.redFlag === 1;
    this.cancelReddot();
  }
  created() {
    this.init();
  }
}
